export const REGISTER_SET = 'REGISTER_SET'
export const REGISTER_LOAD = 'REGISTER_LOAD'
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_FAILED = 'REGISTER_FAILED'
